import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'
import type { UserToolConfigProvider } from '@empathyco/playboard-core-domain'
import type { Store } from 'vuex'
import { interfaces } from 'inversify'
import { TYPES } from '../config/inversify.types'
import { CONFIG_CONSTS } from '../store/config/config.consts'
import Context = interfaces.Context

export function getPlatformUserToolConfigProvider({ container }: Context): UserToolConfigProvider {
  return () => {
    const store = container.get<Store<unknown>>(TYPES.Store)
    const instances = store.getters[
      `${CONFIG_CONSTS.moduleName}/${CONFIG_CONSTS.getters.instances}`
    ] as Array<Instance>
    return {
      instances: instances.map(instance => instance.id),
    }
  }
}
